import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducerMap, StoreModule } from '@ngrx/store';

import {
  CompanyUsersStateKey,
  FeatureFlagStateKey,
  TeamListStateKey,
  UserListStateKey,
  appEntitiesStateKey,
} from './app-entities-keys';
import { CompanyUsersStateEffects } from './company-users/company-users-state.effects';
import { CompanyUsersStateModel } from './company-users/company-users-state.model';
import { CompanyUsersStateReducer } from './company-users/company-users-state.reducer';
import { FeatureFlagStateEffects } from './feature-flag/feature-flag-state.effects';
import { FeatureFlagStateModel } from './feature-flag/feature-flag-state.model';
import { featureFlagStateReducer } from './feature-flag/feature-flag-state.reducer';
import { TeamListStateEffects } from './team-list/team-list-state.effects';
import { TeamListStateModel } from './team-list/team-list-state.model';
import { teamListStateReducer } from './team-list/team-list-state.reducer';
import { UserListStateEffects } from './user-list/user-list-state.effects';
import { UserListStateModel } from './user-list/user-list-state.model';
import { UserListStateReducer } from './user-list/user-list-state.reducer';

export interface AppEntitiesState {
  [FeatureFlagStateKey]: FeatureFlagStateModel;
  [CompanyUsersStateKey]: CompanyUsersStateModel;
  [TeamListStateKey]: TeamListStateModel;
  [UserListStateKey]: UserListStateModel;
}

export const appEntitiesStateReducers: ActionReducerMap<AppEntitiesState> = {
  [FeatureFlagStateKey]: featureFlagStateReducer,
  [CompanyUsersStateKey]: CompanyUsersStateReducer,
  [TeamListStateKey]: teamListStateReducer,
  [UserListStateKey]: UserListStateReducer,
};

@NgModule({
  imports: [
    StoreModule.forFeature(appEntitiesStateKey, appEntitiesStateReducers),
    EffectsModule.forFeature([
      FeatureFlagStateEffects,
      CompanyUsersStateEffects,
      TeamListStateEffects,
      UserListStateEffects,
    ]),
  ],
})
export class AppEntitiesStateModule {}
